import { HttpErrorResponse } from '@angular/common/http';

export const getApiErrorMessage = (error: HttpErrorResponse): string =>
  typeof error?.error === 'string' && error.error.trim() ? error.error : 'errors.serverCommunicationError';
